// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg width=%2712%27 height=%2710%27 viewBox=%270 0 12 10%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 5L4.2 8L11 1%27 stroke=%27white%27 stroke-width=%272%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SalesMode_salesRoot__ot09L {
  --topMenuH: 200px;   
  --sideMenuW: 280px;  
  position: fixed;
  inset: 0;
  z-index: 1000;
}

.SalesMode_actions__07PYT button {
  text-align: center;
}

.SalesMode_canvas__d1u2s {
  position: absolute;
  inset: 0;
  background: #fff;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, border-radius 0.3s ease, box-shadow 0.3s ease;
}

.SalesMode_canvasShift__TUPxf {
    transform: translate(calc(-1 * var(--sideMenuW)), var(--topMenuH));
    box-shadow: 0 8px 24px rgba(0,0,0,0.18);
}

.SalesMode_canvasShift__TUPxf::after {
  content: "";
  position: absolute;
  top: 0; /* отступ сверху под верхнее меню */
  left: 0;
  width: 100%;
  height: calc(100% - var(--topMenuH));
  background: rgba(0, 0, 0, 0.5); /* полупрозрачный фон */
  z-index: 998; /* меньше чем бургер, но больше чем контент */
  pointer-events: auto; /* чтобы можно было кликнуть для закрытия */
}

.SalesMode_header__v157l {
  width: 100%;
  background: #ffffff;
  padding: 14px 24px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  border-bottom: 1px solid #e6e6e6;
}

.SalesMode_left__4EMMn {
  display: flex;
  align-items: center;
  gap: 28px;
}

.SalesMode_logo__ltC7x {
  width: 50px;
  font-size: 24px;
  font-weight: 700;
  color: #1a8b4d;
}

.SalesMode_infoItem__uVRqU {
  display: flex;
  align-items: center;
  gap: 8px;
}

.SalesMode_icon__Owbi1 {
  font-size: 20px;
  color: #1a8b4d;
}

.SalesMode_infoTitle__mMlSR {
  font-size: 15px;
  font-weight: 600;
}

.SalesMode_infoSubtitle__AuI5N {
  font-size: 12px;
  color: #777;
  margin-top: -2px;
}

.SalesMode_right__PZDg5 {
  display: flex;
  align-items: center;
  gap: 22px;
}

.SalesMode_navBtn__8AIa3 {
  background: none;
  border: none;
  font-size: 15px;
  cursor: pointer;
  padding: 6px 10px;
  color: #444;
  transition: 0.2s;
}

.SalesMode_navBtn__8AIa3:hover {
  color: #1a8b4d;
}

.SalesMode_active__gn7HD {
  color: #1a8b4d;
  font-weight: 600;
  border-bottom: 2px solid #1a8b4d;
}

.SalesMode_burger__kzL8G {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}


.SalesMode_actionBtn__-ImYi,
.SalesMode_burgerBtn__OFWxj,
.SalesMode_closeBtn__ZBJeO,
.SalesMode_menuClose__bbXWa {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 15px;
}

.SalesMode_closeBtn__ZBJeO {
  font-size: 18px;
}

.SalesMode_body__H6SRJ {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f5f5f5;
  padding: 12px;
  overflow: hidden; /* важно, чтобы скролл был внутри списков */
}

.SalesMode_topMenu__jYocE {
  position: absolute;
  top: calc(-1 * var(--topMenuH));
  left: 0;
  width: 100%;
  height: var(--topMenuH);
  background: #f5f5f7;
  border-bottom: 1px solid #e5e5ea;
  box-shadow: 0 6px 16px rgba(0,0,0,0.12);
  transition: top 0.3s ease;
  z-index: 1010; 
  padding: 16px 20px;
}

.SalesMode_topMenu__jYocE.SalesMode_open__A3cFc {
  top: 0;
}

.SalesMode_topButtons__wb0Zy {
  display: flex;
  gap: 16px;
}

.SalesMode_topBtn__vb21i {
  width: 180px;
  height: 120px;
  border: 1px solid #e5e5e5;
  border-radius: 12px;
  background: #fff;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;

  font-size: 14px;
  cursor: pointer;
  transition: 0.2s;
}

.SalesMode_topBtn__vb21i:hover {
  background: #f7f7f7;
}


/* ПРАВАЯ ПАНЕЛЬ (оверлей) */
.SalesMode_sideMenu__uBzs9 {
  position: absolute;
  top: 0;
  right: calc(-1 * var(--sideMenuW));
  width: var(--sideMenuW);
  height: 100%;
  background: #fafafa;
  border-left: 1px solid #e5e5ea;
  box-shadow: -6px 0 16px rgba(0,0,0,0.12);
  transition: right 0.3s ease;
  z-index: 1010; /* выше canvas */
  padding: 20px;
  padding-top: 50px;
}

.SalesMode_sideMenu__uBzs9.SalesMode_open__A3cFc {
  right: 0;
}

.SalesMode_sideMenu__uBzs9 ul {
  text-align: right;
  list-style: none;
  padding: 0;
  margin: 0;
}

.SalesMode_sideMenu__uBzs9 li {
  padding: 12px 0;
  border-bottom: 1px solid #e9e9ee;
  cursor: pointer;
  font-size: 16px;
}

.SalesMode_menuClose__bbXWa {
  position: absolute;
  top: 12px;
  right: 12px;
}

.SalesMode_body__H6SRJ {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f5f5f5;
  padding: 12px;
}

/* Поиск */
.SalesMode_searchBar__aWVhd {
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 10px 15px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  gap: 15px;
  position: relative;
}

.SalesMode_searchInputWrap__MsI-4 {
  flex: 1 1;
  position: relative;
}

.SalesMode_searchInputWrap__MsI-4 input {
  width: 100%;
  padding: 10px 40px 10px 35px;
  border-radius: 8px;
  border: 1px solid #ddd;
  font-size: 14px;
  outline: none;
  transition: border 0.2s;
}

.SalesMode_searchInputWrap__MsI-4 input:focus {
  border-color: rgba(29, 135, 82, 1);
  box-shadow: 0 0 0 2px rgba(29, 135, 82, 0.2);
}

.SalesMode_searchIcon__M2YNn {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #888;
  font-size: 18px;
}

.SalesMode_searchDropdown__0WnRq {
  position: absolute;
  top: 105%;
  left: 0;
  width: 100%;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  z-index: 10;
  max-height: 250px;
  overflow-y: auto;
}

.SalesMode_searchItem__UYj3x {
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  transition: background-color 0.15s;
}

.SalesMode_searchItem__UYj3x:hover {
  background-color: #f3f3ff;
}

.SalesMode_price__ypOjg {
  font-weight: 600;
  color: rgba(29, 135, 82, 1);
}

.SalesMode_searchActions__WjLLt {
  display: flex;
  gap: 10px;
}

.SalesMode_actionBtn__-ImYi {
  background-color: rgba(29, 135, 82, 1);
  color: #fff;
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: background-color 0.2s;
}

.SalesMode_actionBtn__-ImYi:hover {
  background-color: rgba(29, 135, 82, 1);
}

.SalesMode_searchInputWrap__MsI-4 {
  flex: 1 1;
  position: relative; /* важно */
}

.SalesMode_searchDropdown__0WnRq {
  position: absolute;
  top: 105%; 
  left: 0;
  width: 100%;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  z-index: 50;
  max-height: 250px;
  overflow-y: auto;
}

/* Список */

.SalesMode_empty__SzIUb {
  text-align: center;
  color: #888;
}

.SalesMode_emptyy__PLdEC {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  width: 100%;
  align-content: start;
  justify-items: stretch;
}


.SalesMode_empty__SzIUb img {
  width: 90px;
  margin-bottom: 6px;
  margin-top: 130px;
}

/* Итог */
.SalesMode_footer__dSvgh {
  display: flex;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 10px;
}

/* Левая часть */
.SalesMode_leftPanel__nqvud {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 12px;
  border-right: 1px solid #ddd;
  min-width: 600px;
  background: #fafafa;
}

.SalesMode_summary__ToSfU {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

.SalesMode_summary__ToSfU p {
  margin: 4px 0;
}

.SalesMode_clearBtn__Qktlo {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 8px;
  font-size: 14px;
  cursor: pointer;
  color: #c0392b;
  font-weight: 500;
  transition: 0.2s;
}

.SalesMode_clearBtn__Qktlo:hover {
  background: #ffeaea;
  border-color: #e0b4b4;
}

/* Правая часть */
.SalesMode_actions__07PYT {
  flex: 1 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 60px;
  gap: 8px;
  padding: 10px;
  background: #fafafa;
}

.SalesMode_actions__07PYT button {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: 0.2s;
}

.SalesMode_actions__07PYT button:hover {
  background: #f5f5f5;
}

/* Специальные кнопки */
.SalesMode_actions__07PYT .SalesMode_delete__DlCZJ {
  background: #f8d7da;
  border: 1px solid #f5c2c7;
  color: #b02a37;
  font-weight: 600;
}

.SalesMode_actions__07PYT .SalesMode_delete__DlCZJ:hover {
  background: #f1b0b7;
}

.SalesMode_actions__07PYT .SalesMode_pay__J5KIr {
  background: rgba(29,135,82,1);
  color: #fff;
  border: none;
  font-weight: 600;
}

.SalesMode_actions__07PYT .SalesMode_pay__J5KIr:hover {
  background: rgba(24,115,70,1);
}


.SalesMode_itemsWrapper__iSYNI {
  display: flex;
  width: 100%;
  flex: 1 1;          /* ✅ занимает всю оставшуюся высоту */
  min-height: 0;    /* ✅ чтобы внутренний overflow работал */
  transition: all 0.4s ease;
  gap: 0;
  margin: 0;        /* ✅ убираем зазоры */
}

.SalesMode_checkboxContainer__xP\\+sv {
  display: inline-block;
  position: relative;
  cursor: pointer;
  width: 18px;
  height: 18px;
}

.SalesMode_checkboxContainer__xP\\+sv input {
  opacity: 0;
  width: 0;
  height: 0;
}

.SalesMode_customCheckbox__i95nw {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: white;
  border: 2px solid #1D8752;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.SalesMode_checkboxContainer__xP\\+sv input:checked + .SalesMode_customCheckbox__i95nw {
  background-color: #1D8752;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
}


.SalesMode_itemsWrapper__iSYNI.SalesMode_split__IYxq3 {
  gap: 12px; 
}

.SalesMode_itemsList__SufMp {
  flex: 1 1;
  margin-top: 10px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.4s ease;
}

.SalesMode_itemsWrapper__iSYNI.SalesMode_split__IYxq3 .SalesMode_itemsList__SufMp {
  flex: 0.5 1; 
  overflow: auto;
}

.SalesMode_itemsWrapper__iSYNI .SalesMode_itemsList__SufMp:first-child{
  overflow-y: auto;
  display: block;
}

.SalesMode_rightList__GxPeU {
  display: block;          /* убираем центрирование flex'ом */
  padding: 12px;
}

.SalesMode_itemsWrapper__iSYNI.SalesMode_split__IYxq3 .SalesMode_rightList__GxPeU {
  display: block;
}

/* Только для правой панели убираем центрирование */
.SalesMode_itemsList__SufMp.SalesMode_rightList__GxPeU {
  justify-content: flex-start;
  align-items: flex-start;
}


@keyframes SalesMode_fadeIn__jT51d {
  from { opacity: 0; transform: translateX(50px); }
  to { opacity: 1; transform: translateX(0); }
}

.SalesMode_btnText__Y1xmW {
  display: block;
  white-space: normal;
  word-break: break-word;
  text-align: center;
  line-height: 1.2;
  max-width: 100%;
}


/* Кнопка "Без категорий" */
.SalesMode_noCategoryBtn__tr8IV {
  width: 85%;
  min-height: 53px;              /* чтобы было как блок */
  border-radius: 10px;
  padding: 12px;

  color: white;
  background: rgba(29,135,82,1);

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  
}


.SalesMode_noCategoryBtn__tr8IV:hover {
  background: rgba(24,115,70,1);
}


/* 🔹 Общий фон модалки */
.SalesMode_modalOverlay__FJU-L {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* 🔹 Окно модалки */
.SalesMode_modal__Xlmoc {
  background: #fff;
  padding: 30px 25px;
  border-radius: 16px;
  width: 380px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  animation: SalesMode_fadeIn__jT51d 0.3s ease;
}

/* 🔹 Заголовки и текст */
.SalesMode_modal__Xlmoc h2 {
  font-size: 22px;
  margin-bottom: 15px;
  color: #333;
}

.SalesMode_modal__Xlmoc p {
  font-size: 14px;
  color: #555;
  margin: 8px 0;
}

/* 🔹 Поле суммы */
.SalesMode_amountDisplay__4eSTw {
  background: #f8f9fa;
  border: 2px solid #ddd;
  border-radius: 10px;
  font-size: 26px;
  font-weight: bold;
  padding: 15px;
  margin: 20px auto;
  text-align: right;
  color: #222;
  width: 100%;
  box-sizing: border-box;
}

/* 🔹 Цифровая клавиатура */
.SalesMode_numPad__TklIG {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin: 20px 0;
}

.SalesMode_numPad__TklIG button {
  background: #f1f3f5;
  border: none;
  border-radius: 12px;
  padding: 18px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 3px 6px rgba(0,0,0,0.1);
}

.SalesMode_numPad__TklIG button:hover {
  background: #e0e4e7;
  transform: scale(1.05);
}

/* 🔹 Кнопки действий */
.SalesMode_modalActions__\\+Jh2o {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

.SalesMode_modalActions__\\+Jh2o button {
  flex: 1 1;
  padding: 14px 0;
  margin: 0 5px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.SalesMode_modalActions__\\+Jh2o button:first-child {
  background: #28a745;
  color: white;
}

.SalesMode_modalActions__\\+Jh2o button:first-child:hover {
  background: #218838;
}

.SalesMode_modalActions__\\+Jh2o button:last-child {
  background: #dee2e6;
  color: #333;
}

.SalesMode_modalActions__\\+Jh2o button:last-child:hover {
  background: #ced4da;
}

@keyframes SalesMode_fadeIn__jT51d {
  from {
    opacity: 0;
    transform: translateY(-15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* add to SalesMode.module.css */

.SalesMode_TableWrapper__yuimO {
  max-height: 27vw;
  overflow-y: auto; 
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  position: relative; 
}

.SalesMode_cartTable__dgTLe {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.SalesMode_cartTable__dgTLe thead th {
  position: sticky;
  top: 0; 
  z-index: 5;
  background-color: #f9f9f9;
}

.SalesMode_cartTable__dgTLe thead th {
  background: rgba(232, 243, 237, 1);
  font-weight: 600;
  font-size: 0.95rem;
  color: rgba(29, 135, 82, 1);
}

.SalesMode_page__Nkzkl {
  color: red;
}
.SalesMode_cartTable__dgTLe th,
.SalesMode_cartTable__dgTLe td {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
  font-size: 14px;
}

.SalesMode_cartTable__dgTLe th {
  background-color: #f9f9f9;
  font-weight: 600;
  color: #333;
}

.SalesMode_cartTable__dgTLe tr:hover {
  background-color: #f5f5f5;
}

.SalesMode_qtyContainer__SpqX5 {
  display: flex;
  align-items: center;
  gap: 5px;
}

.SalesMode_qtyBtn__bedYu {
  width: 25px;
  height: 25px;
  border: none;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  font-weight: bold;
}

.SalesMode_qtyValue__1Pmre {
  min-width: 20px;
  text-align: center;
}

.SalesMode_deleteBtn__\\+Pg5f {
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
}


/* ===== FOOTER ROOT ===== */
.SalesMode_footer__dSvgh {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  background: #fff;
  border-top: 1px solid #e5e7eb;
}

/* ===== LEFT BLOCK ===== */
.SalesMode_footerLeft__OzVEo {
  flex: 1 1;
  border: 1px dashed rgba(29, 135, 82, 1);
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.SalesMode_footerTop__fPRu4 {
  display: flex;
  gap: 6px;
  font-size: 20px;
  color: #111;
}

/* ===== ACTION BUTTONS ===== */
.SalesMode_footerActions__ETTX8 {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.SalesMode_footerBtn__oD\\+Bx {
  min-width: 90px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 13px;
  color: #111;
  transition: all 0.2s ease;
}

.SalesMode_footerBtn__oD\\+Bx svg {
  font-size: 20px;
  color: rgba(29, 135, 82, 1);
}

.SalesMode_footerBtn__oD\\+Bx:hover {
  background: #f9fafb;
  border-color: rgba(29, 135, 82, 0.4);
}

/* ===== DELETE / DANGER ===== */
.SalesMode_danger__t3Boy {
  border-color: #ef4444;
  color: #ef4444;
}

.SalesMode_danger__t3Boy svg {
  color: #ef4444;
}

.SalesMode_danger__t3Boy:hover {
  background: #fff5f5;
}

/* ===== RIGHT BLOCK ===== */
.SalesMode_footerRight__e1j31 {
  width: 320px;
  border: 1px dashed rgba(29, 135, 82, 1);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* ===== TOTAL ===== */
.SalesMode_total__qhXQK {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
}

.SalesMode_total__qhXQK span {
  color: #6b7280;
}

/* ===== PAY BUTTON ===== */
.SalesMode_pay__J5KIr {
  margin-top: 16px;
  background: rgba(29, 135, 82, 1);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 14px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
}

.SalesMode_pay__J5KIr:hover {
  background: rgba(24, 115, 70, 1);
}

.SalesMode_shiftError__0QYH\\+ {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(255, 69, 0, 0.95);
  color: #fff;
  padding: 10px 20px;
  border-radius: 8px;
  z-index: 9999;
  animation: SalesMode_fadeInOut__6nQ0\\+ 5s forwards;
}

@keyframes SalesMode_fadeInOut__6nQ0\\+ {
  0% { opacity: 0; transform: translateX(-50%) translateY(20px); }
  10% { opacity: 1; transform: translateX(-50%) translateY(0); }
  90% { opacity: 1; transform: translateX(-50%) translateY(0); }
  100% { opacity: 0; transform: translateX(-50%) translateY(20px); }
}

.SalesMode_holdsBar__rAkMx {
  display: flex;
  gap: 10px;
  padding-top: 10px;
}

.SalesMode_holdTab__GDlPw {
  display: flex;
  align-items: center;
  background: white;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  border: 1px solid #1d8752; 

}

.SalesMode_activeHold__9fNls {
  background: #1d8752;
  color: #fff;
}

.SalesMode_holdClose__T5Y1\\+ {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: inherit;
}

`, "",{"version":3,"sources":["webpack://./src/styles/SalesMode.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8EAA8E;AAChF;;AAEA;IACI,kEAAkE;IAClE,uCAAuC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,mCAAmC;EAC3C,OAAO;EACP,WAAW;EACX,oCAAoC;EACpC,8BAA8B,EAAE,uBAAuB;EACvD,YAAY,EAAE,6CAA6C;EAC3D,oBAAoB,EAAE,2CAA2C;AACnE;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;;AAGA;;;;EAIE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,gBAAgB,EAAE,2CAA2C;AAC/D;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,OAAO;EACP,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,uCAAuC;EACvC,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;;EAEhB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;;EAET,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,MAAM;EACN,kCAAkC;EAClC,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;EACxC,2BAA2B;EAC3B,aAAa,EAAE,gBAAgB;EAC/B,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,SAAO;EACP,kBAAkB,EAAE,UAAU;AAChC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,sBAAsB;AACxB;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,QAAQ;EACR,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,SAAO,WAAW,qCAAqC;EACvD,aAAa,KAAK,wCAAwC;EAC1D,yBAAyB;EACzB,MAAM;EACN,SAAS,SAAS,qBAAqB;AACzC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yDAAsO;EACtO,4BAA4B;EAC5B,2BAA2B;AAC7B;;;AAGA;EACE,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc,WAAW,kCAAkC;EAC3D,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;;AAGA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;;AAGA,2BAA2B;AAC3B;EACE,UAAU;EACV,gBAAgB,eAAe,wBAAwB;EACvD,mBAAmB;EACnB,aAAa;;EAEb,YAAY;EACZ,6BAA6B;;EAE7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;;AAErB;;;AAGA;EACE,6BAA6B;AAC/B;;;AAGA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,4CAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,gCAAgC;;AAEhC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;;AAGA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,SAAO;EACP,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,wCAAwC;EACxC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,kDAAgC;AAClC;;AAEA;EACE,KAAK,UAAU,EAAE,4CAA4C,EAAE;EAC/D,MAAM,UAAU,EAAE,yCAAyC,EAAE;EAC7D,MAAM,UAAU,EAAE,yCAAyC,EAAE;EAC7D,OAAO,UAAU,EAAE,4CAA4C,EAAE;AACnE;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;;AAE3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,cAAc;AAChB","sourcesContent":[".salesRoot {\n  --topMenuH: 200px;   \n  --sideMenuW: 280px;  \n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n}\n\n.actions button {\n  text-align: center;\n}\n\n.canvas {\n  position: absolute;\n  inset: 0;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.3s ease, border-radius 0.3s ease, box-shadow 0.3s ease;\n}\n\n.canvasShift {\n    transform: translate(calc(-1 * var(--sideMenuW)), var(--topMenuH));\n    box-shadow: 0 8px 24px rgba(0,0,0,0.18);\n}\n\n.canvasShift::after {\n  content: \"\";\n  position: absolute;\n  top: 0; /* отступ сверху под верхнее меню */\n  left: 0;\n  width: 100%;\n  height: calc(100% - var(--topMenuH));\n  background: rgba(0, 0, 0, 0.5); /* полупрозрачный фон */\n  z-index: 998; /* меньше чем бургер, но больше чем контент */\n  pointer-events: auto; /* чтобы можно было кликнуть для закрытия */\n}\n\n.header {\n  width: 100%;\n  background: #ffffff;\n  padding: 14px 24px;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  border-bottom: 1px solid #e6e6e6;\n}\n\n.left {\n  display: flex;\n  align-items: center;\n  gap: 28px;\n}\n\n.logo {\n  width: 50px;\n  font-size: 24px;\n  font-weight: 700;\n  color: #1a8b4d;\n}\n\n.infoItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.icon {\n  font-size: 20px;\n  color: #1a8b4d;\n}\n\n.infoTitle {\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.infoSubtitle {\n  font-size: 12px;\n  color: #777;\n  margin-top: -2px;\n}\n\n.right {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n}\n\n.navBtn {\n  background: none;\n  border: none;\n  font-size: 15px;\n  cursor: pointer;\n  padding: 6px 10px;\n  color: #444;\n  transition: 0.2s;\n}\n\n.navBtn:hover {\n  color: #1a8b4d;\n}\n\n.active {\n  color: #1a8b4d;\n  font-weight: 600;\n  border-bottom: 2px solid #1a8b4d;\n}\n\n.burger {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n}\n\n\n.actionBtn,\n.burgerBtn,\n.closeBtn,\n.menuClose {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 15px;\n}\n\n.closeBtn {\n  font-size: 18px;\n}\n\n.body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: #f5f5f5;\n  padding: 12px;\n  overflow: hidden; /* важно, чтобы скролл был внутри списков */\n}\n\n.topMenu {\n  position: absolute;\n  top: calc(-1 * var(--topMenuH));\n  left: 0;\n  width: 100%;\n  height: var(--topMenuH);\n  background: #f5f5f7;\n  border-bottom: 1px solid #e5e5ea;\n  box-shadow: 0 6px 16px rgba(0,0,0,0.12);\n  transition: top 0.3s ease;\n  z-index: 1010; \n  padding: 16px 20px;\n}\n\n.topMenu.open {\n  top: 0;\n}\n\n.topButtons {\n  display: flex;\n  gap: 16px;\n}\n\n.topBtn {\n  width: 180px;\n  height: 120px;\n  border: 1px solid #e5e5e5;\n  border-radius: 12px;\n  background: #fff;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n\n  font-size: 14px;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.topBtn:hover {\n  background: #f7f7f7;\n}\n\n\n/* ПРАВАЯ ПАНЕЛЬ (оверлей) */\n.sideMenu {\n  position: absolute;\n  top: 0;\n  right: calc(-1 * var(--sideMenuW));\n  width: var(--sideMenuW);\n  height: 100%;\n  background: #fafafa;\n  border-left: 1px solid #e5e5ea;\n  box-shadow: -6px 0 16px rgba(0,0,0,0.12);\n  transition: right 0.3s ease;\n  z-index: 1010; /* выше canvas */\n  padding: 20px;\n  padding-top: 50px;\n}\n\n.sideMenu.open {\n  right: 0;\n}\n\n.sideMenu ul {\n  text-align: right;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.sideMenu li {\n  padding: 12px 0;\n  border-bottom: 1px solid #e9e9ee;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.menuClose {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n}\n\n.body {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: #f5f5f5;\n  padding: 12px;\n}\n\n/* Поиск */\n.searchBar {\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  padding: 10px 15px;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  gap: 15px;\n  position: relative;\n}\n\n.searchInputWrap {\n  flex: 1;\n  position: relative;\n}\n\n.searchInputWrap input {\n  width: 100%;\n  padding: 10px 40px 10px 35px;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n  font-size: 14px;\n  outline: none;\n  transition: border 0.2s;\n}\n\n.searchInputWrap input:focus {\n  border-color: rgba(29, 135, 82, 1);\n  box-shadow: 0 0 0 2px rgba(29, 135, 82, 0.2);\n}\n\n.searchIcon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #888;\n  font-size: 18px;\n}\n\n.searchDropdown {\n  position: absolute;\n  top: 105%;\n  left: 0;\n  width: 100%;\n  background-color: #fff;\n  border: 1px solid #eee;\n  border-radius: 8px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n  max-height: 250px;\n  overflow-y: auto;\n}\n\n.searchItem {\n  padding: 10px 15px;\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n  transition: background-color 0.15s;\n}\n\n.searchItem:hover {\n  background-color: #f3f3ff;\n}\n\n.price {\n  font-weight: 600;\n  color: rgba(29, 135, 82, 1);\n}\n\n.searchActions {\n  display: flex;\n  gap: 10px;\n}\n\n.actionBtn {\n  background-color: rgba(29, 135, 82, 1);\n  color: #fff;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  transition: background-color 0.2s;\n}\n\n.actionBtn:hover {\n  background-color: rgba(29, 135, 82, 1);\n}\n\n.searchInputWrap {\n  flex: 1;\n  position: relative; /* важно */\n}\n\n.searchDropdown {\n  position: absolute;\n  top: 105%; \n  left: 0;\n  width: 100%;\n  background-color: #fff;\n  border: 1px solid #eee;\n  border-radius: 8px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n  z-index: 50;\n  max-height: 250px;\n  overflow-y: auto;\n}\n\n/* Список */\n\n.empty {\n  text-align: center;\n  color: #888;\n}\n\n.emptyy {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n  width: 100%;\n  align-content: start;\n  justify-items: stretch;\n}\n\n\n.empty img {\n  width: 90px;\n  margin-bottom: 6px;\n  margin-top: 130px;\n}\n\n/* Итог */\n.footer {\n  display: flex;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  overflow: hidden;\n  margin-top: 10px;\n}\n\n/* Левая часть */\n.leftPanel {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 12px;\n  border-right: 1px solid #ddd;\n  min-width: 600px;\n  background: #fafafa;\n}\n\n.summary {\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.summary p {\n  margin: 4px 0;\n}\n\n.clearBtn {\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 8px;\n  font-size: 14px;\n  cursor: pointer;\n  color: #c0392b;\n  font-weight: 500;\n  transition: 0.2s;\n}\n\n.clearBtn:hover {\n  background: #ffeaea;\n  border-color: #e0b4b4;\n}\n\n/* Правая часть */\n.actions {\n  flex: 1;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-auto-rows: 60px;\n  gap: 8px;\n  padding: 10px;\n  background: #fafafa;\n}\n\n.actions button {\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.actions button:hover {\n  background: #f5f5f5;\n}\n\n/* Специальные кнопки */\n.actions .delete {\n  background: #f8d7da;\n  border: 1px solid #f5c2c7;\n  color: #b02a37;\n  font-weight: 600;\n}\n\n.actions .delete:hover {\n  background: #f1b0b7;\n}\n\n.actions .pay {\n  background: rgba(29,135,82,1);\n  color: #fff;\n  border: none;\n  font-weight: 600;\n}\n\n.actions .pay:hover {\n  background: rgba(24,115,70,1);\n}\n\n\n.itemsWrapper {\n  display: flex;\n  width: 100%;\n  flex: 1;          /* ✅ занимает всю оставшуюся высоту */\n  min-height: 0;    /* ✅ чтобы внутренний overflow работал */\n  transition: all 0.4s ease;\n  gap: 0;\n  margin: 0;        /* ✅ убираем зазоры */\n}\n\n.checkboxContainer {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  width: 18px;\n  height: 18px;\n}\n\n.checkboxContainer input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.customCheckbox {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 18px;\n  width: 18px;\n  background-color: white;\n  border: 2px solid #1D8752;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.checkboxContainer input:checked + .customCheckbox {\n  background-color: #1D8752;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg width='12' height='10' viewBox='0 0 12 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 5L4.2 8L11 1' stroke='white' stroke-width='2'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n\n.itemsWrapper.split {\n  gap: 12px; \n}\n\n.itemsList {\n  flex: 1;\n  margin-top: 10px;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.4s ease;\n}\n\n.itemsWrapper.split .itemsList {\n  flex: 0.5; \n  overflow: auto;\n}\n\n.itemsWrapper .itemsList:first-child{\n  overflow-y: auto;\n  display: block;\n}\n\n.rightList {\n  display: block;          /* убираем центрирование flex'ом */\n  padding: 12px;\n}\n\n.itemsWrapper.split .rightList {\n  display: block;\n}\n\n/* Только для правой панели убираем центрирование */\n.itemsList.rightList {\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateX(50px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n.btnText {\n  display: block;\n  white-space: normal;\n  word-break: break-word;\n  text-align: center;\n  line-height: 1.2;\n  max-width: 100%;\n}\n\n\n/* Кнопка \"Без категорий\" */\n.noCategoryBtn {\n  width: 85%;\n  min-height: 53px;              /* чтобы было как блок */\n  border-radius: 10px;\n  padding: 12px;\n\n  color: white;\n  background: rgba(29,135,82,1);\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 14px;\n  font-weight: 600;\n  white-space: nowrap;\n  \n}\n\n\n.noCategoryBtn:hover {\n  background: rgba(24,115,70,1);\n}\n\n\n/* 🔹 Общий фон модалки */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n/* 🔹 Окно модалки */\n.modal {\n  background: #fff;\n  padding: 30px 25px;\n  border-radius: 16px;\n  width: 380px;\n  text-align: center;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.2);\n  animation: fadeIn 0.3s ease;\n}\n\n/* 🔹 Заголовки и текст */\n.modal h2 {\n  font-size: 22px;\n  margin-bottom: 15px;\n  color: #333;\n}\n\n.modal p {\n  font-size: 14px;\n  color: #555;\n  margin: 8px 0;\n}\n\n/* 🔹 Поле суммы */\n.amountDisplay {\n  background: #f8f9fa;\n  border: 2px solid #ddd;\n  border-radius: 10px;\n  font-size: 26px;\n  font-weight: bold;\n  padding: 15px;\n  margin: 20px auto;\n  text-align: right;\n  color: #222;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* 🔹 Цифровая клавиатура */\n.numPad {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  margin: 20px 0;\n}\n\n.numPad button {\n  background: #f1f3f5;\n  border: none;\n  border-radius: 12px;\n  padding: 18px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 3px 6px rgba(0,0,0,0.1);\n}\n\n.numPad button:hover {\n  background: #e0e4e7;\n  transform: scale(1.05);\n}\n\n/* 🔹 Кнопки действий */\n.modalActions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 25px;\n}\n\n.modalActions button {\n  flex: 1;\n  padding: 14px 0;\n  margin: 0 5px;\n  border: none;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.modalActions button:first-child {\n  background: #28a745;\n  color: white;\n}\n\n.modalActions button:first-child:hover {\n  background: #218838;\n}\n\n.modalActions button:last-child {\n  background: #dee2e6;\n  color: #333;\n}\n\n.modalActions button:last-child:hover {\n  background: #ced4da;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-15px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* add to SalesMode.module.css */\n\n.TableWrapper {\n  max-height: 27vw;\n  overflow-y: auto; \n  overflow-x: auto;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  position: relative; \n}\n\n.cartTable {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n\n.cartTable thead th {\n  position: sticky;\n  top: 0; \n  z-index: 5;\n  background-color: #f9f9f9;\n}\n\n.cartTable thead th {\n  background: rgba(232, 243, 237, 1);\n  font-weight: 600;\n  font-size: 0.95rem;\n  color: rgba(29, 135, 82, 1);\n}\n\n.page {\n  color: red;\n}\n.cartTable th,\n.cartTable td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  text-align: left;\n  font-size: 14px;\n}\n\n.cartTable th {\n  background-color: #f9f9f9;\n  font-weight: 600;\n  color: #333;\n}\n\n.cartTable tr:hover {\n  background-color: #f5f5f5;\n}\n\n.qtyContainer {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.qtyBtn {\n  width: 25px;\n  height: 25px;\n  border: none;\n  border-radius: 4px;\n  text-align: center;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.qtyValue {\n  min-width: 20px;\n  text-align: center;\n}\n\n.deleteBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 2px;\n}\n\n\n/* ===== FOOTER ROOT ===== */\n.footer {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px;\n  background: #fff;\n  border-top: 1px solid #e5e7eb;\n}\n\n/* ===== LEFT BLOCK ===== */\n.footerLeft {\n  flex: 1;\n  border: 1px dashed rgba(29, 135, 82, 1);\n  border-radius: 8px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.footerTop {\n  display: flex;\n  gap: 6px;\n  font-size: 20px;\n  color: #111;\n}\n\n/* ===== ACTION BUTTONS ===== */\n.footerActions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.footerBtn {\n  min-width: 90px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  color: #111;\n  transition: all 0.2s ease;\n}\n\n.footerBtn svg {\n  font-size: 20px;\n  color: rgba(29, 135, 82, 1);\n}\n\n.footerBtn:hover {\n  background: #f9fafb;\n  border-color: rgba(29, 135, 82, 0.4);\n}\n\n/* ===== DELETE / DANGER ===== */\n.danger {\n  border-color: #ef4444;\n  color: #ef4444;\n}\n\n.danger svg {\n  color: #ef4444;\n}\n\n.danger:hover {\n  background: #fff5f5;\n}\n\n/* ===== RIGHT BLOCK ===== */\n.footerRight {\n  width: 320px;\n  border: 1px dashed rgba(29, 135, 82, 1);\n  border-radius: 8px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n/* ===== TOTAL ===== */\n.total {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 20px;\n}\n\n.total span {\n  color: #6b7280;\n}\n\n/* ===== PAY BUTTON ===== */\n.pay {\n  margin-top: 16px;\n  background: rgba(29, 135, 82, 1);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 14px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.pay:hover {\n  background: rgba(24, 115, 70, 1);\n}\n\n.shiftError {\n  position: fixed;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: rgba(255, 69, 0, 0.95);\n  color: #fff;\n  padding: 10px 20px;\n  border-radius: 8px;\n  z-index: 9999;\n  animation: fadeInOut 5s forwards;\n}\n\n@keyframes fadeInOut {\n  0% { opacity: 0; transform: translateX(-50%) translateY(20px); }\n  10% { opacity: 1; transform: translateX(-50%) translateY(0); }\n  90% { opacity: 1; transform: translateX(-50%) translateY(0); }\n  100% { opacity: 0; transform: translateX(-50%) translateY(20px); }\n}\n\n.holdsBar {\n  display: flex;\n  gap: 10px;\n  padding-top: 10px;\n}\n\n.holdTab {\n  display: flex;\n  align-items: center;\n  background: white;\n  gap: 6px;\n  padding: 6px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  border: 1px solid #1d8752; \n\n}\n\n.activeHold {\n  background: #1d8752;\n  color: #fff;\n}\n\n.holdClose {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  color: inherit;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"salesRoot": `SalesMode_salesRoot__ot09L`,
	"actions": `SalesMode_actions__07PYT`,
	"canvas": `SalesMode_canvas__d1u2s`,
	"canvasShift": `SalesMode_canvasShift__TUPxf`,
	"header": `SalesMode_header__v157l`,
	"left": `SalesMode_left__4EMMn`,
	"logo": `SalesMode_logo__ltC7x`,
	"infoItem": `SalesMode_infoItem__uVRqU`,
	"icon": `SalesMode_icon__Owbi1`,
	"infoTitle": `SalesMode_infoTitle__mMlSR`,
	"infoSubtitle": `SalesMode_infoSubtitle__AuI5N`,
	"right": `SalesMode_right__PZDg5`,
	"navBtn": `SalesMode_navBtn__8AIa3`,
	"active": `SalesMode_active__gn7HD`,
	"burger": `SalesMode_burger__kzL8G`,
	"actionBtn": `SalesMode_actionBtn__-ImYi`,
	"burgerBtn": `SalesMode_burgerBtn__OFWxj`,
	"closeBtn": `SalesMode_closeBtn__ZBJeO`,
	"menuClose": `SalesMode_menuClose__bbXWa`,
	"body": `SalesMode_body__H6SRJ`,
	"topMenu": `SalesMode_topMenu__jYocE`,
	"open": `SalesMode_open__A3cFc`,
	"topButtons": `SalesMode_topButtons__wb0Zy`,
	"topBtn": `SalesMode_topBtn__vb21i`,
	"sideMenu": `SalesMode_sideMenu__uBzs9`,
	"searchBar": `SalesMode_searchBar__aWVhd`,
	"searchInputWrap": `SalesMode_searchInputWrap__MsI-4`,
	"searchIcon": `SalesMode_searchIcon__M2YNn`,
	"searchDropdown": `SalesMode_searchDropdown__0WnRq`,
	"searchItem": `SalesMode_searchItem__UYj3x`,
	"price": `SalesMode_price__ypOjg`,
	"searchActions": `SalesMode_searchActions__WjLLt`,
	"empty": `SalesMode_empty__SzIUb`,
	"emptyy": `SalesMode_emptyy__PLdEC`,
	"footer": `SalesMode_footer__dSvgh`,
	"leftPanel": `SalesMode_leftPanel__nqvud`,
	"summary": `SalesMode_summary__ToSfU`,
	"clearBtn": `SalesMode_clearBtn__Qktlo`,
	"delete": `SalesMode_delete__DlCZJ`,
	"pay": `SalesMode_pay__J5KIr`,
	"itemsWrapper": `SalesMode_itemsWrapper__iSYNI`,
	"checkboxContainer": `SalesMode_checkboxContainer__xP+sv`,
	"customCheckbox": `SalesMode_customCheckbox__i95nw`,
	"split": `SalesMode_split__IYxq3`,
	"itemsList": `SalesMode_itemsList__SufMp`,
	"rightList": `SalesMode_rightList__GxPeU`,
	"btnText": `SalesMode_btnText__Y1xmW`,
	"noCategoryBtn": `SalesMode_noCategoryBtn__tr8IV`,
	"modalOverlay": `SalesMode_modalOverlay__FJU-L`,
	"modal": `SalesMode_modal__Xlmoc`,
	"fadeIn": `SalesMode_fadeIn__jT51d`,
	"amountDisplay": `SalesMode_amountDisplay__4eSTw`,
	"numPad": `SalesMode_numPad__TklIG`,
	"modalActions": `SalesMode_modalActions__+Jh2o`,
	"TableWrapper": `SalesMode_TableWrapper__yuimO`,
	"cartTable": `SalesMode_cartTable__dgTLe`,
	"page": `SalesMode_page__Nkzkl`,
	"qtyContainer": `SalesMode_qtyContainer__SpqX5`,
	"qtyBtn": `SalesMode_qtyBtn__bedYu`,
	"qtyValue": `SalesMode_qtyValue__1Pmre`,
	"deleteBtn": `SalesMode_deleteBtn__+Pg5f`,
	"footerLeft": `SalesMode_footerLeft__OzVEo`,
	"footerTop": `SalesMode_footerTop__fPRu4`,
	"footerActions": `SalesMode_footerActions__ETTX8`,
	"footerBtn": `SalesMode_footerBtn__oD+Bx`,
	"danger": `SalesMode_danger__t3Boy`,
	"footerRight": `SalesMode_footerRight__e1j31`,
	"total": `SalesMode_total__qhXQK`,
	"shiftError": `SalesMode_shiftError__0QYH+`,
	"fadeInOut": `SalesMode_fadeInOut__6nQ0+`,
	"holdsBar": `SalesMode_holdsBar__rAkMx`,
	"holdTab": `SalesMode_holdTab__GDlPw`,
	"activeHold": `SalesMode_activeHold__9fNls`,
	"holdClose": `SalesMode_holdClose__T5Y1+`
};
export default ___CSS_LOADER_EXPORT___;
